export default __webpack_public_path__ + "static/media/mcqueen.51caa046.svg";